"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SOCIALS_SETTINGS_MAP = void 0;
var _social = require("../../../../types/social");
const SOCIALS_SETTINGS_MAP = exports.SOCIALS_SETTINGS_MAP = {
  [_social.ESocialType.VK]: {
    icon: require('../../icons/vk.svg'),
    title: 'ВКонтакте'
  },
  [_social.ESocialType.Facebook]: {
    icon: require('../../icons/facebook.svg'),
    title: 'Facebook'
  },
  [_social.ESocialType.Google]: {
    icon: require('../../icons/google.svg'),
    title: 'Google'
  },
  [_social.ESocialType.OK]: {
    icon: require('../../icons/ok.svg'),
    title: 'Одноклассники'
  },
  [_social.ESocialType.MailRu]: {
    icon: require('../../icons/mailru.svg'),
    title: 'Почта Mail.Ru'
  },
  [_social.ESocialType.AppleID]: {
    icon: require('../../icons/apple.svg'),
    title: 'Apple ID'
  },
  [_social.ESocialType.Gosuslugi]: {
    icon: require('../../icons/gosuslugi.svg'),
    title: 'Госуслуги'
  }
};